import React from 'react';
import {withStyles, Grid, Typography } from '@material-ui/core';
import future from '../assets/future.png';
import styles from '../config/styles';
import living from '../assets/aboutUs/living.png';
import hardwarePrototyping from '../assets/aboutUs/hardwarePrototyping.png';
import urbanPollution from '../assets/aboutUs/urbanPollution.png';

class AboutUs extends React.Component{

    render(){
        const {classes} = this.props;
        return(
            <section id="aboutUs" className={classes.section}>
            <div className={classes.innerBox}>
                <div className={classes.innerHeaderSection}>
                    <Typography variant="h4" >
                    Hardware Product Design Studio
                    </Typography>
                    <Typography variant="subtitle1" >
                    We are a bunch of futurists who believe in building products with the perfect balance of design & utility.
                    </Typography>
                </div>
                <div>
                    <img src={future} className={classes.centerImage} alt="Dream. Build. Repat" />
                </div>
                <Typography variant="h4" className={classes.centered} gutterBottom>
                    Our focus areas
                </Typography>
                <Grid container justify="space-around" spacing={32}>
                    <Grid item xs={12} sm={4} md={3} lg={4}>                        
                        <div className={classes.centered}>
                            <img src={living}  className={classes.aboutUsIcon} alt="Healthy Stress-Free Living" />
                            <Typography variant="h6"  gutterBottom >
                                Healthy Stress-Free Living
                            </Typography>
                            {/* <Typography variant="subheading" style={{textAlign: "justify"}}>
                                Most of our time in our busy lives is consumed by everyday chores. We are automating these mundane chores and so that we can use the time on what we really care for.
                            </Typography> */}
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3} lg={4}>                        
                        <div className={classes.centered}>
                            <img src={urbanPollution}  className={classes.aboutUsIcon} alt="Urban Pollution"/>
                            <Typography variant="h6" align='center' gutterBottom >
                                Urban Pollution
                            </Typography>
                            {/* <Typography variant="subheading" style={{textAlign: "justify"}}>
                                Pollution level cities has risen drastically over the decade. We are working on something that helps us breathe better.
                            </Typography> */}
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3} lg={4}>                        
                        <div className={classes.centered}>
                            <img src={hardwarePrototyping}  className={classes.aboutUsIcon} alt="Hardware Prototyping" />
                            <Typography variant="h6" align='center' gutterBottom >
                                Hardware Prototyping
                            </Typography>
                            {/* <Typography variant="subheading" style={{textAlign: "justify"}}>
                                The turnaround time for hardware product compared to software app is rather long. We are making hardware prototyping as simple as compling an app.
                            </Typography> */}
                        </div>
                    </Grid>
                </Grid>
            </div>          
            </section>            
        )
    }
}

export default withStyles(styles)(AboutUs);